// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p1[data-v-46a592bf] {\n  font-size: 0.16rem;\n  color: #000;\n  font-weight: bold;\n  margin-bottom: 0.24rem;\n}\n.main p[data-v-46a592bf] {\n  font-size: 0.14rem;\n  color: #000;\n  margin-bottom: 0.05rem;\n}\n", ""]);
// Exports
module.exports = exports;
